import React from "react";

import MainWavesurfer from "../../AudioReaction/MainWavesurfer";

const AudioConcat = (props) => {
  return <MainWavesurfer {...props} audiodata={props.audiodata} />;
};

export default AudioConcat;
